module.exports = __webpack_public_path__ + "static/media/hbb_grid_6.ba6624da.png";